module.exports = __webpack_public_path__ + "static/media/img_selfie_disabled.62aecbab.svg";